import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
// import PropTypes from "prop-types";
import * as removeActions from "../actions/removeActions";
import StateManager from "../../shared/utils/StateManager";
import {I18nUtils} from "../../../i18n/I18nUtils";
import MachinesTab from "../../shared/components/tabs/machines/MachinesTab";

class RemoveCardTabMachines extends React.Component {

  static TAB_ID = 'machines';

  static renderTabHeader() {
    return (
      <li role="presentation" className="">
        <a href={'#' + this.TAB_ID} data-toggle="tab" aria-expanded="true">{I18nUtils.tr('TR_MAQUINARIA').toUpperCase()}</a>
      </li>
    );
  }

  render() {
    return (
      <div role="tabpanel" className="tab-pane fade" id={RemoveCardTabMachines.TAB_ID}>
        <MachinesTab
          id={StateManager.REMOVE_TAB_MACHINES}
          title={I18nUtils.tr('TR_ELIMINAR_MAQUINARIA')}
          selectedIds={this.props.selectedIds}
          actionSelectItem={this.props.removeActions.checkMachine}
          actionSelectAll={this.props.removeActions.checkMachines}
          selectText={I18nUtils.tr('TR_ELIMINAR')}
          selectAllText={I18nUtils.tr('TR_ELIMINAR_TODO')}
          showOutsource={true}
        />
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const workerIds = state.remove.machines.map(worker => worker.id);
  return {
    selectedIds: workerIds,
  }
};

const mapDispatchToProps = dispatch => ({
  removeActions: bindActionCreators(removeActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoveCardTabMachines)

RemoveCardTabMachines.propTypes = {
};

RemoveCardTabMachines.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/remove/components/RemoveCardTabMachines.js